export default __webpack_public_path__ + "static/fall28-879b8eaea7d95967558566122f89a8a0.webp";